<template>
  <v-card class="shading__list-card">
    <v-card-text>
      <v-card-title style="display: flex; align-items: center; justify-content: space-between;">
        <span class="text-h5">All Shadings</span>
        <div>
          <v-btn text @click="resetShadings">
            <v-icon left>
              mdi-backup-restore
            </v-icon>
            Reset defaults
          </v-btn>
          <v-btn tile color="success" @click="addShading">
            <v-icon left>
              mdi-plus
            </v-icon>
            Add New Shading
          </v-btn>
        </div>
      </v-card-title>
    </v-card-text>
    <v-card-text>
      <v-container>
        <div>
          <!-- <div class="shgc__calc">
            <Shgc />
          </div> -->
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    Shading Name
                  </th>
                  <th class="text-center">
                    Overhang (H)
                  </th>
                  <th class="text-center">
                    Overhang (V)
                  </th>
                  <th class="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- <template v-for="shading in shadings"> -->
                <tr v-for="shading in shadings">
                  <td>{{ shading.title }}</td>
                  <td class="text-center">{{ shading.overhangH }}</td>
                  <td class="text-center">{{ shading.overhangV }}</td>
                  <td class="text-center">
                    <v-btn icon fab @click="editShading(shading.id)" x-small>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <!-- </template> -->
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-container>
    </v-card-text>
    <shgc v-if="showModal" :show="showModal" @close="showModal = false" :shading="selectedShading" />
  </v-card>
</template>

<script>
import Shgc from '@/components/shgc/Shgc.vue';
import { defaultShadings } from '@/store/default';
export default {
  components: {
    Shgc,
  },
  data() {
    return {
      showModal: false,
      selectedShading: null,
    };
  },
  computed: {
    shadings: {
      get: function() {
        return this.$store.state.shadings;
      },
      set: function(newShadings) {
        this.$store.dispatch('setShadings', newShadings);
      },
    },
  },
  mounted() {
    console.log('Shadings', this.shadings);
  },
  methods: {
    editShading(id) {
      let index = this.shadings.findIndex(item => item.id === id);
      if (index !== -1) {
        this.selectedShading = this.shadings[index];
        console.log('Selected Shading', this.selectedShading);
        this.showModal = true;
      }
    },
    addShading() {
      this.selectedShading = null;
      this.showModal = true;
    },
    resetShadings() {
      this.shadings = JSON.parse(JSON.stringify(defaultShadings));
      localStorage.setItem('shadings', JSON.stringify(defaultShadings));
    },
  },
};
</script>

<style lang="scss">
.shading__list-card {
  margin-top: 76px;
  margin-bottom: 44px;
}
.shgc__calc {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}
</style>
